import React from "react";
import { ArrowRight, Smartphone } from "lucide-react";
import { Link } from "react-router-dom";
import { API_PORTAL_URL } from "../../constants/links";
import { useLanguage } from "../../i18n/LanguageProvider";
import RevealOnScroll from "../RevealOnScroll";

const HomeFinalCta = () => {
  const { t } = useLanguage();

  return (
    <section
      className="ws-section ws-home-final-section"
      aria-labelledby="ws-home-final-title"
    >
      <RevealOnScroll className="ws-shell ws-home-final-cta" variant="scale-in">
        <div className="ws-home-final-cta__pattern" aria-hidden="true" />
        <div>
          <span className="ws-kicker">WonyaSoft</span>
          <h2 id="ws-home-final-title">
            {t("Prêt à moderniser vos paiements ?")}
          </h2>
          <p>
            {t(
              "Intégrez WonyaPay, lancez vos paiements en masse ou développez une solution adaptée à votre organisation.",
            )}
          </p>
        </div>
        <div className="ws-button-row">
          <a
            className="ws-button ws-button--light"
            href={API_PORTAL_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Démarrer l’intégration")}{" "}
            <ArrowRight size={18} aria-hidden="true" />
          </a>
          <Link className="ws-button ws-button--glass" to="/appmobile">
            <Smartphone size={18} aria-hidden="true" />{" "}
            {t("Découvrir l’application")}
          </Link>
          <Link className="ws-button ws-button--glass" to="/contact">
            {t("Contacter notre équipe")}
          </Link>
        </div>
      </RevealOnScroll>
    </section>
  );
};

export default HomeFinalCta;
